const ClubDocumentsEnum = {
    COMPANY_REGISTRATION_STATEMENT: 'CompanyRegistrationStatement',
    ICO_ASSIGNMENT_CONFIRMATION: 'ICOAssignmentConfirmation',
    DIC_REGISTRATION_STATEMENT: 'DICRegistrationStatement',
    MINUTE_OF_THE_INAUGURAL_MEETING: 'MinuteOfTheInauguralMeeting',
    STATUTES_OF_THE_CIVIC_ASSOCIATION: 'StatutesOfTheCivicAssociation',
}
export default ClubDocumentsEnum;
